// Wallet event emitter utility for the AlphaMind IDO Frontend
import { WalletType } from '../types/logging.types';

interface WalletEventDetail {
  walletType: WalletType;
  action: string;
  data?: Record<string, any>;
}

interface WalletConnectEventDetail {
  address?: string;
  connector?: string;
  error?: Error;
  chainId?: number;
}

// Emit custom wallet events that the WalletEventMonitor can capture
export const emitWalletEvent = (detail: WalletEventDetail) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('wallet-event', { detail });
    window.dispatchEvent(event);
  }
};

// Emit wallet connection attempt event
export const emitWalletConnectAttempt = (walletType: WalletType, data?: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('wallet-connect-attempt', { 
      detail: { walletType, ...data } 
    });
    window.dispatchEvent(event);
  }
};

// Emit wallet connection success event
export const emitWalletConnectSuccess = (detail: WalletConnectEventDetail) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('wallet-connect-success', { detail });
    window.dispatchEvent(event);
  }
};

// Emit wallet connection error event
export const emitWalletConnectError = (detail: WalletConnectEventDetail) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('wallet-connect-error', { detail });
    window.dispatchEvent(event);
  }
};

// Emit wallet disconnect event
export const emitWalletDisconnect = (walletType: WalletType, data?: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('wallet-disconnect', { 
      detail: { walletType, ...data } 
    });
    window.dispatchEvent(event);
  }
};

// Emit network change event
export const emitNetworkChange = (chainId: number, networkName?: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('network-change', { 
      detail: { chainId, networkName, ...data } 
    });
    window.dispatchEvent(event);
  }
};

// Force flush logs immediately (for critical wallet events)
export const forceFlushWalletLogs = () => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent('force-flush-logs');
    window.dispatchEvent(event);
  }
};

export default {
  emitWalletEvent,
  emitWalletConnectAttempt,
  emitWalletConnectSuccess,
  emitWalletConnectError,
  emitWalletDisconnect,
  emitNetworkChange,
  forceFlushWalletLogs
};
